import { sanitizeHtml, bodyToHtml } from "../lib/sanitizeHtml";

// Renders a policy revision. PDF-first RAMS/MS revisions embed the authoritative PDF (with an
// open/download fallback); everything else renders the rich-text body.
export function PolicyContent({ body, pdfUrl, pdfFilename, isPdf, pdfAccess }) {
  if (isPdf && !pdfUrl) {
    return (
      <div data-testid="policy-pdf-noaccess" className="rounded-lg border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900">
        This document is a PDF. {pdfAccess === false
          ? "You don't currently have access to view it — it only applies to people actively assigned to its client/job."
          : "No viewable file is attached to the current version."}
      </div>
    );
  }
  if (pdfUrl) {
    return (
      <div data-testid="policy-pdf">
        <object data={pdfUrl} type="application/pdf" className="w-full h-[72vh] rounded-lg border border-slate-200 bg-slate-50">
          <div className="p-6 text-sm text-slate-600">This document is a PDF and can't be embedded here.
            <a href={pdfUrl} target="_blank" rel="noreferrer" className="text-emerald-700 underline ml-1">Open / download the PDF</a>.</div>
        </object>
        <div className="mt-2 text-sm">
          <a data-testid="pdf-download" href={pdfUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-emerald-700 hover:text-emerald-800 underline font-medium">Open / download {pdfFilename || "PDF"}</a>
        </div>
      </div>
    );
  }
  const html = bodyToHtml(body);
  if (!html) {
    return <p className="font-body text-slate-400 italic">No readable content has been added to this revision yet.</p>;
  }
  return <div className="prose-tmic policy-html" data-testid="policy-content" dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }} />;
}
